import { LegacyDataTable, LegacyDataTableBody, LegacyDataTableHeader, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import InternalLink from "~/components/Navigation/InternalLink/InternalLink";
import type { CertificateUsageEntry } from "./certificateUsageSummary";
interface Props {
    certificateUsage: CertificateUsageEntry[];
}
const CertificateUsage = (props: Props) => {
    return (props.certificateUsage && (<div>
                {props.certificateUsage.length === 0 && <p>This certificate is not used anywhere</p>}
                {props.certificateUsage.length > 0 && (<LegacyDataTable>
                        <LegacyDataTableHeader>
                            <LegacyDataTableRow>
                                <LegacyDataTableHeaderColumn>Source</LegacyDataTableHeaderColumn>
                                <LegacyDataTableHeaderColumn>Type</LegacyDataTableHeaderColumn>
                            </LegacyDataTableRow>
                        </LegacyDataTableHeader>
                        <LegacyDataTableBody>
                            {props.certificateUsage.map((usage: CertificateUsageEntry) => (<LegacyDataTableRow key={usage.ownerName}>
                                    <LegacyDataTableRowColumn>
                                        <InternalLink to={usage.ownerLink}>{usage.ownerName}</InternalLink>
                                    </LegacyDataTableRowColumn>
                                    <LegacyDataTableRowColumn>{usage.ownerType}</LegacyDataTableRowColumn>
                                </LegacyDataTableRow>))}
                        </LegacyDataTableBody>
                    </LegacyDataTable>)}
            </div>));
};
export default CertificateUsage;
